import { HateoasLink } from "components/types";
import { components } from "library/api/card-management-service.generated";

export interface AddressError {
  type: "NOT_FOUND" | "RESTRICTED" | "INTERNAL_ERROR";
  message: string;
}

export enum AddressFormat {
  masked = "masked",
  full = "full",
}

export type FullAddress = components["schemas"]["FullAddress"];

export interface MultiMaskedAccount {
  token: string;
  type: AddressFormat.masked;
  restricted?: boolean;
  residential: string;
  mailing: string;
  email?: string;
  home_phone: string;
  mobile_phone: string;
  work_phone: string;
  error?: AddressError;
}

export interface MultiFullAccount {
  token: string;
  email?: string;
  mobile_phone?: string;
  home_phone?: string;
  work_phone?: string;
  type: AddressFormat.full;
  residential?: FullAddress;
  mailing?: FullAddress;
  error?: AddressError;
  links: HateoasLink[];
}

export type AddressesApiResponse = {
  accounts: (MultiMaskedAccount | MultiFullAccount)[];
  links: HateoasLink[];
};

export enum ReasonForChangeEnum {
  Update = "update",
  Correction = "correction",
}

export enum ErrorHttpStatusCode {
  NUMBER_400 = 400,
  NUMBER_401 = 401,
  NUMBER_403 = 403,
  NUMBER_404 = 404,
  NUMBER_422 = 422,
  NUMBER_500 = 500,
}
export enum ErrorType {
  BAD_REQUEST = "BAD_REQUEST",
  UNAUTHORIZED = "UNAUTHORIZED",
  REQUIRED_2FA = "2FA_REQUIRED",
  NOT_FOUND = "NOT_FOUND",
  FORBIDDEN = "FORBIDDEN",
  REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

export interface ErrorParam {
  field?: string;
  reason?: string;
}

export type UpdateAddressResponse =
  components["schemas"]["UpdateAddressResponse"];

export type ApiError = components["schemas"]["ApiError"];
